module.exports = __webpack_public_path__ + "static/media/thomas-claeys-SrbXjbo-XbQ-unsplash.0d4129ae.jpg";